import { render } from "./UserAuth.vue?vue&type=template&id=6472c37c&scoped=true"
import script from "./UserAuth.vue?vue&type=script&lang=js"
export * from "./UserAuth.vue?vue&type=script&lang=js"

import "./UserAuth.vue?vue&type=style&index=0&id=6472c37c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ACER\\Desktop\\Vue Course\\Main Course Project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6472c37c"]])

export default __exports__